import { type UseQueryResult, useQuery } from 'react-query';

import { TableParamsType } from '../../types/common';
import { PublishedReportTemplateService } from '@wealthlane/api-services/wealthlane-report-service';
import { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts } from '@wealthlane/api-services/wealthlane-report-service';
import type { Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType } from '@wealthlane/api-services/wealthlane-report-service';

const useGetPublishedReportTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  listType?: Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts
  | undefined,
  unknown
> => {
  const { categoryTypeId, areaTypeId, filter, sorting, skipCount, maxResultCount } = tableInfo;

  const publishedReportTemplateList = useQuery(
    [
      'getPublishedReportTemplateList',
      categoryTypeId,
      areaTypeId,
      listType,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        PublishedReportTemplateService.getApiReportApiAppPublishedReportTemplatePublishedReportTemplates(
          categoryTypeId,
          areaTypeId,
          listType,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return publishedReportTemplateList;
};

export default useGetPublishedReportTemplateList;
